export default __webpack_public_path__ + "static/media/homepageImage.463c3f52.png";